import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loader from "../../Components/Global/Loader";
import DashboardLayouts from "../../Components/Layout/DashboardLayouts";
import { useAuth } from "../../Context/AuthContext";
import Paginations from "../../hooks/Paginations";
import useAuthentication from "../../hooks/useAuthentication";
import useSearchListPagination from "../../hooks/useSearchListPagination";
import BackToDashboardBtn from "./BackToDashboardBtn";
import TablesList from "./TablesList";

//Table haeder list base on page


const fieldNameData = [
  {
    id: "worker",
    value: [
      "Sl No.",
      "Name",
      "Role",
      // "Buildings",
      "No.of Tasks",
      "Completed Tasks",
      "Pending Tasks",
      // "In progress Tasks",
      "Status",
      "Action",
    ],
  },
  {
    id: "owner",
    value: [
      "Sl No.",
      "Name",
      "Address",
      "Phone ",
      "Email ",
      "Status",
      "Action",
    ],
  },
  {
    id: "partner",
    value: [
      "Sl No.",
      "Partner Name",
      "Username",
      "Partner Address",
      "Email",
      "Status",
      "Action",
    ],
  },
  {
    id: "manager",
    value: [
      "Sl No.",
      "Name",
      "Address",
      "Phone ",
      "No. of Building ",
      "Status",
      "Action",
    ],
  },
  {
    id: "accountant",
    value: [
      "Sl No.",
      "Name",
      "Address",
      "Phone ",
      "Email ",
      "Status",
      "Action",
    ],
  },
  {
    id: "request",
    value: [
      "Sl No.",
      "Request",
      "Receiver",
      "Building ",
      "Unit ",
      "Type",
      "Action",
    ],
  },

  {
    id: "task",
    value: [
      "Sl No.",
      "Task",
      "Assigned to",
      "Issue By ",
      "Issue Date ",
      "Deadline Date",
      "Receiver status",
      "Action",
    ],
  },
  {
    id: "building",
    value: [
      "Sl No.",
      "Building Name",
      "Building Address",
      "Description",
      "Status",
      "Action",
    ],
  },
  {
    id: "tenant",
    value: [
      "Sl No.",
      "Name",
      // "Tenant ID",
      "Building Name",
      "Unit	Type",
      "Lease Start",
      "Lease End",
      "Action",
    ],
  },
];

//Table body list variable base on page


const fieldValueData = [
  {
    id: "worker",
    value: [
      "fullName",
      "worker_roles",
      // "fullAddress",
      "task",
      "CompleteSatus",
      "PendingSatus",
      // "InProgressSatus",
      "status",
    ],
    design: ["n", "n", "n", "n", "n"],
  },
  {
    id: "owner",
    value: ["fullName", "fullAddress", "phone_number", "email", "status"],
    design: ["n", "n", "n", "n", "n"],
  },
  {
    id: "partner",
    value: ["fullName", "username", "fullAddress", "email", "status"],
    design: ["n", "n", "n", "n", "n"],
  },
  {
    id: "manager",
    value: [
      "fullName",
      "fullAddress",
      "phone_number",
      "AssignBuildings",
      "status",
    ],
    design: ["n", "n", "n", "n", "n"],
  },
  {
    id: "accountant",
    value: ["fullName", "fullAddress", "phone_number", "email", "status"],
    design: ["n", "n", "n", "n", "n"],
  },
  {
    id: "request",
    value: [
      "task_title",
      "requestReceiversList",
      "requestBuildingName",
      "requestUnitName",
      "task_category",
    ],
    design: ["n", "n", "n", "n", "n"],
  },
  {
    id: "task",
    value: [
      "task_title",
      "workerName",
      "issueBytenantName",
      "createdAt",
      "deadline",
      "receiver_status",
    ],
    design: ["n", "n", "n", "n", "n"],
  },
  {
    id: "building",
    value: ["building_name", "fullAddress", "Description", "status"],
    design: ["n", "n", "n", "n", "n"],
  },
  {
    id: "tenant",
    value: [
      "fullName",
      // "fullAddress",
      "building_name",
      "unit_type",
      "lease_start_date",
      "lease_end_date",
    ],
    design: ["n", "n", "n", "n", "n"],
  },
];

function ViewProfileListGlobal({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);

  const { designation, userDetails } = useAuth();

  const [tableNameData, setTableNameData] = useState([]);
  const [tableValueData, setTableValueData] = useState({
    value: [],
    design: [],
  });
  const [datasShow, setdatasShow] = useState([]);
  const location = useLocation();
  const pathname = location.pathname;
  const [makeUrl, setMakeUrl] = useState({
    navigateUrl: "",
    apiUrl: "",
    EditItem: true,
  });
//Search list pagination api calls

  const {
    setisKeyPress,
    Count,
    setsearchKey,
    searchKey,
    setRecord,
    record,
    setPages,
    pages,
    totallength,
    paginationLoading,
    handleNextbtn,
    handlePrevbtn,
    PageShowFunc,
    SearchListApi,
    allData,
    PagesFunc,
    responseData,
  } = useSearchListPagination();

  

  const source = axios.CancelToken.source();
  useEffect(() => {
    if (makeUrl.apiUrl) {
      if (searchKey) {
        SearchListApi(`${makeUrl.apiUrl}`, source);
      } else {
        SearchListApi(`${makeUrl.apiUrl}`, source);
      }
    }
    return () => source.cancel();
  }, [searchKey, record, pages, makeUrl]);

  useEffect(() => {
    if (pathname.includes("partner")) {
      const isEdit = designation == "Admin" ? false : true;
      setMakeUrl({
        EditItem: isEdit,

        apiUrl: "partner",
        navigateUrl: "/partnerlist",
      });
    }
    if (pathname.includes("owner")) {
      setMakeUrl({
        EditItem: false,
        apiUrl: "owner",
        navigateUrl: "/ownerlist",
      });
    }
    if (pathname.includes("manager")) {
      const isEdit = designation == "Admin" ? false : true;
      setMakeUrl({
        EditItem: isEdit,

        apiUrl: "manager",
        navigateUrl: "/managerlist",
      });
    }
    if (pathname.includes("accountant")) {
      const isEdit = designation == "Admin" ? false : true;
      setMakeUrl({
        EditItem: isEdit,
        apiUrl: "accountant",
        navigateUrl: "/accountantlist",
      });
    }
    if (pathname.includes("worker")) {
      const isEdit = designation == "Admin" ? false : true;
      setMakeUrl({
        EditItem: isEdit,
        apiUrl: "worker",
        navigateUrl: "/workerlist",
      });
    }
    if (pathname.includes("request")) {
      const isEdit = designation == "Admin" ? false : true;
      setMakeUrl({
        EditItem: isEdit,
        apiUrl: "request",
        navigateUrl: "/requestlist",
      });
    }
    if (pathname.includes("building")) {
      const isEdit =
        designation !== "Owner" && designation !== "Partner" ? false : true;
      setMakeUrl({
        EditItem: isEdit,
        apiUrl: "building",
        navigateUrl: "/buildinglist",
      });
    }
    if (pathname.includes("tenant")) {
      const isEdit = designation == "Admin" ? false : true;
      setMakeUrl({
        EditItem: isEdit,
        apiUrl: "tenant",
        navigateUrl: "/tenantlist",
      });
    }
    if (pathname.includes("task")) {
      let isEdit = true;
      if (datasShow?.request_id) {
        isEdit = responseData?.result?.AssignId.includes(datasShow?.created_by)
          ? true
          : false;
      }

      isEdit =
        designation !== "Tenant" && designation !== "Worker" ? true : false;

      setMakeUrl({
        EditItem: isEdit,
        apiUrl: "task",
        navigateUrl: "/tasklist",
      });

      // setMakeUrl({EditItem:true, apiUrl: "task", navigateUrl: "/tasklist" });
    }
  }, [pathname, designation]);

  useEffect(() => {
    setTableNameData(fieldNameData.find((f) => f.id == makeUrl.apiUrl)?.value);
    setTableValueData({
      value: fieldValueData.find((f) => f.id == makeUrl.apiUrl)?.value,
      design: fieldValueData.find((f) => f.id == makeUrl.apiUrl)?.design,
    });
  }, [makeUrl]);

//set data for list 


  useEffect(() => {
    const ggg = allData?.map((data, i) => ({
      ...data,

      issueBytenantName: allData[i]?.request_id
        ? `${allData[i]?.unitId?.tenantId?.first_name} ${allData[i]?.unitId?.tenantId?.middle_name} ${allData[i]?.unitId?.tenantId?.last_name}`
        : `request raise by ${userDetails?.first_name} ${userDetails?.last_name} (${designation})`,
      isEditableItem: allData[i]?.request_id
        ? allData[i]?.created_by !== userDetails?.id
          ? false
          : true
        : true,
      requestBuildingName:
        data?.User?.AdditionalTenantDetails[0]?.Building?.building_name,
      requestUnitName: data?.User?.AdditionalTenantDetails[0]?.Unit?.unit_name,
      requestReceiversList: data?.RequestAssigns,
      fullName: `${data?.first_name} ${data?.middle_name} ${data?.last_name}`,
      workerName: `${data?.workerId?.first_name} ${
        data?.workerId?.middle_name !== null ? data?.workerId?.middle_name : ""
      } ${data?.workerId?.last_name}`,
      managerlist: data?.AssignBuildings,
      fullAddress: `${data?.address ? data?.address : ""} ${
        data?.address ? "," : ""
      } ${data?.street_address ? data?.street_address.slice(0, 45) : ""}  ${
        data?.street_address ? "," : ""
      } ${data?.apartment ? data?.apartment : ""} ${
        data?.apartment ? "," : ""
      } ${data?.country_name ? data?.country_name : ""} ${
        data?.country_name ? "," : ""
      } ${data?.postal_code ? data?.postal_code : ""}`,
    }));
    setdatasShow(ggg);
  }, [allData, designation]);

  const StatusFunc = (e, idstatus) => {
    e.preventDefault();

    axios
      .post(`/task/update/${idstatus}`, {
        id: idstatus,
        tenant_status: e.target.value,
      })
      .then((res) => {
        if (res?.data) {
          // apiurl(`/tenant/task/list`);
        }
      });
  };

  const navigate = useNavigate();
  const onClickEditFunc = (item) => {
    navigate(
      designation == "Owner" || designation == "Partner"
        ? `/add${makeUrl.apiUrl}/${item.id}`
        : `/${designation.toLowerCase()}/add${makeUrl.apiUrl}/${item.id}`
    );
  };

  return (
    <>
      <DashboardLayouts>
        {/* {paginationLoading && <Loader />} */}
        {(paginationLoading || allowLoading) && <Loader />}
        <div className="breadcrumb row justify-content-between align-items-center">
          <BackToDashboardBtn />

          {makeUrl.apiUrl !== "request" && (
            <div className="col-auto btn-responsive">
              {makeUrl.EditItem && (
                <Link
                  to={
                    makeUrl.apiUrl == "request"
                      ? `/addtask`
                      : designation == "Owner" || designation == "Partner"
                      ? `/add${makeUrl.apiUrl}`
                      : `/${designation.toLowerCase()}/add${makeUrl.apiUrl}`
                  }
                  // to={`/add${makeUrl.apiUrl}`}
                  className="btn btn-outline-primary"
                >
                  Add {makeUrl.apiUrl}
                </Link>
              )}
            </div>
          )}
        </div>

        <>
          <TablesList
            isEditIconShow={true}
            // isDeleteIconShow={true}
            isViewIconShow={true}
            tableNameData={tableNameData}
            onClickEditFunc={onClickEditFunc}
            designation={designation}
            tableValueData={tableValueData}
            datasShow={datasShow}
            setPages={setPages}
            pages={pages}
            record={record}
            setRecord={setRecord}
            setsearchKey={setsearchKey}
            setisKeyPress={setisKeyPress}
            searchKey={searchKey}
            SearchListApi={SearchListApi}
            showTitle={true}
            title={makeUrl.apiUrl}
            navigateUrl={makeUrl.apiUrl}
            isSearchField={true}
          />
        </>
        {Count > 5 && totallength.length > 1 && (
          <Paginations
            onPageChange={PagesFunc}
            currentPage={pages}
            totalPages={totallength.length}
          />
        )}
      </DashboardLayouts>
    </>
  );
}

export default ViewProfileListGlobal;
